module.exports = __webpack_public_path__ + "media/honey-icons/icon-home-type-flat-06345153.svg";